import axios from 'axios';

/**
 * Получение подсказок адресов от Яндекс Геокодера
 * @param query Строка адреса
 * @param results Кол-во результатов (по умолчанию 5)
 * @returns Массив строк адресов
 */
export async function getAddressSuggestions(query: string, results: number = 5): Promise<string[]> {
    if (!query || query.length < 3) return [];

    try {
        const { data } = await axios.post('/axios/yandex/geocode', { query });
        return data?.suggestions ?? [];
    } catch (error) {
        console.error('Ошибка при получении подсказок адресов:', error);
        return [];
    }
}
